import React from 'react';

import SkeletonLoader from './index';

const NotificationDetailsSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col gap-5 w-full">
      <SkeletonLoader className="h-6 w-32" variant="text" />
      <SkeletonLoader className="h-10 w-full" variant="rect" />

      <SkeletonLoader className="h-24 w-full" variant="rect" />

      <SkeletonLoader className="h-10 w-full" variant="rect" />
      <SkeletonLoader className="h-6 w-48 mt-2" variant="text" />

      <SkeletonLoader className="h-10 w-full" variant="rect" />
      <SkeletonLoader className="h-6 w-40 mt-2" variant="text" />

      <div className="flex gap-4">
        <SkeletonLoader className="h-10 w-full flex-1" variant="rect" />
        <SkeletonLoader className="h-10 w-full flex-1" variant="rect" />
      </div>
    </div>
  );
};

export default NotificationDetailsSkeleton;
